/* eslint-disable no-console */
import * as msal from '@azure/msal-browser';

// Get client ID from environment
const clientId = process.env.REACT_APP_CLIENT_ID;

if (!clientId) {
    console.warn('REACT_APP_CLIENT_ID is not set in environment variables');
}

// MSAL configuration for multi-tenant
const msalConfig = {
    auth: {
        clientId: clientId || '',
        authority: 'https://login.microsoftonline.com/common', // Multi-tenant
        redirectUri: window.location.origin,
    },
    cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: false,
    },
};

const msalInstance = new msal.PublicClientApplication(msalConfig);

// Initialize MSAL
msalInstance.initialize().then(() => {
    // Set active account on login success
    msalInstance.addEventCallback((event) => {
        if (event.eventType === msal.EventType.LOGIN_SUCCESS) {
            msalInstance.setActiveAccount(event?.payload?.account);
        }
    });
});

export const loginRequest = {
    scopes: ['openid', 'profile', 'User.Read'],
};

export const accessTokenScope = [
    process.env.REACT_APP_CLIENT_ID ? `${process.env.REACT_APP_CLIENT_ID}/.default` : 'User.Read',
];

export { msalInstance };
